const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentTimeRow.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import moment from 'moment';
import { KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';

type AppointmentTimeProps = {
    appointment: StructuredAppointment;
};

export const AppointmentTimeRow = (props: AppointmentTimeProps) => {
    const { appointment } = props;

    const startDate = moment(appointment.STARTDAT, KISIM_TIME_FORMAT);
    const endDate = moment(appointment.STOPDAT, KISIM_TIME_FORMAT);
    const fullFormat = 'dddd, Do MMMM YYYY HH:mm';
    const startText = startDate.format(fullFormat);
    const endTimeText = startDate.isSame(endDate, 'day') ? endDate.format('HH:mm') : endDate.format(fullFormat);

    return (
        <Grid size={{ xs: 12 }}>
            <Typography>
                {startText} - {endTimeText}
            </Typography>
        </Grid>
    );
};
